export default __webpack_public_path__ + "static/media/porsche.900f2556.svg";